import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LogItemEditorModalComponent} from './components/log-item-editor-modal/log-item-editor-modal.component';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {SharedModule} from '../shared/shared.module';
import {FileUploadModule} from 'primeng/fileupload';
import {FormsModule} from '@angular/forms';
import {TableModule} from 'primeng/table';
import {RouterModule} from '@angular/router';
import {InputTextModule} from 'primeng/inputtext';
import {CommonsModule} from "../common/commons.module";


@NgModule({
  declarations: [LogItemEditorModalComponent],
  imports: [
    CommonModule,
    InputTextModule,
    FontAwesomeModule,
    SharedModule,
    FileUploadModule,
    FormsModule,
    TableModule,
    RouterModule,
    CommonsModule
  ]
})
export class BugLoggerModule {
}
